<div class="d-flex component-generate-map">
  <div class="p-0" [class]="allowCreate?'col-12 col-lg-9':'col-12'">
    <div class="content-generate-canvas" id="container-seats">
      <div class="buttons-zoom-map">
        <button (click)="zoomMap(true)" title="Zoom +">
          <i class="fa-regular fa-plus"></i>
        </button>
        <button (click)="zoomMap(false)" title="Zoom -">
          <i class="fa-regular fa-minus"></i>
        </button>
        <button *ngIf="allowCreate && isSuperAdminEditMode" (click)="undo()" [disabled]="historyStack.length === 0" title="Deshacer (Ctrl+Z)" class="btn-undo-map">
          <i class="fa-regular fa-rotate-left"></i>
        </button>
        <button *ngIf="allowCreate && isSuperAdminEditMode" (click)="toggleMassSelect()"
          [style.background]="massSelectMode ? '#FF4D80' : ''" [style.color]="massSelectMode ? '#fff' : ''"
          [style.borderColor]="massSelectMode ? '#FF4D80' : ''"
          [title]="massSelectMode ? 'Selección múltiple activa: dibuja un recuadro' : 'Selección múltiple'"
          class="btn-undo-map">
          <i class="fa-regular fa-object-group"></i>
        </button>
        <button *ngIf="allowCreate && isSuperAdminEditMode && multiSelectionActive" (click)="duplicateSelected()"
          title="Duplicar selección" class="btn-undo-map">
          <i class="fa-regular fa-clone"></i>
        </button>
        <button *ngIf="allowCreate && isSuperAdminEditMode && multiSelectionActive" (click)="groupSelectionAsLayer()"
          title="Agrupar en una capa" class="btn-undo-map">
          <i class="fa-regular fa-layer-group"></i>
        </button>
      </div>
      <div class="buttons-options-map d-lg-none">
        <button type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" (click)="toggleOffcanvas()"
          aria-controls="offcanvasExample">
          <i class="fal fa-bars"></i>
        </button>
      </div>
      <canvas id="myCanvas"></canvas>
      <!-- Tooltip: pedido al que pertenece una butaca ocupada (al hacer hover en edición de evento) -->
      <div class="seat-order-tooltip" *ngIf="seatOrderTooltip.visible && seatOrderTooltip.data"
        [style.left.px]="seatOrderTooltip.x + 14" [style.top.px]="seatOrderTooltip.y + 14">
        <p class="seat-order-tooltip__title m-0">
          Pedido #{{ seatOrderTooltip.data.invoice_number || seatOrderTooltip.data.order_id }}
        </p>
        <p class="seat-order-tooltip__row m-0" *ngIf="seatOrderTooltip.data.buyer_name">
          <i class="fa-light fa-user"></i> {{ seatOrderTooltip.data.buyer_name }}
        </p>
        <p class="seat-order-tooltip__row m-0" *ngIf="seatOrderTooltip.data.created_at">
          <i class="fa-light fa-calendar"></i>
          {{ seatOrderTooltip.data.created_at | date:'dd/MM/yyyy - HH:mm' }}
        </p>
        <p class="seat-order-tooltip__row m-0" *ngIf="seatOrderChannelLabel(seatOrderTooltip.data)">
          <i class="fa-light fa-store"></i> {{ seatOrderChannelLabel(seatOrderTooltip.data) }}
        </p>
        <p class="seat-order-tooltip__row m-0" *ngIf="seatOrderStatusLabel(seatOrderTooltip.data)">
          <i class="fas fa-circle" [style.color]="seatOrderStatusColor(seatOrderTooltip.data)"
            style="font-size: 8px;"></i>
          <span [style.color]="seatOrderStatusColor(seatOrderTooltip.data)">{{ seatOrderStatusLabel(seatOrderTooltip.data) }}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="aside-options d-none d-lg-block" *ngIf="allowCreate">
    <div *ngIf="openEditScenary">
      <div class="d-flex align-items-center mb-3 title-section" (click)="closeScenaryEdit()">
        <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
        <p class="m-0">Escenario</p>
      </div>
      <div class="panel-group">
        <div class="field field--stacked">
          <label class="field__label">Nombre del escenario</label>
          <input class="field-input" type="text" [(ngModel)]="editingScenaryText"
            (ngModelChange)="updateScenaryText()" placeholder="Escenario" (click)="$event.stopPropagation()" />
        </div>
        <div class="field">
          <label class="field__label">Tamaño de fuente</label>
          <input class="field-input field-input--sm" type="number" min="8" max="120" [(ngModel)]="editingScenaryFontSize"
            (ngModelChange)="updateScenaryFontSize()" (click)="$event.stopPropagation()" />
        </div>
        <div class="field">
          <label class="field__label">Color del escenario</label>
          <div class="field-color">
            <span class="field-input field-input--hex">{{editingScenaryColor}}</span>
            <span class="field-color__swatch">
              <input type="color" [(ngModel)]="editingScenaryColor"
                (ngModelChange)="updateScenaryColor()" (click)="$event.stopPropagation()" />
            </span>
          </div>
        </div>
        <div class="field">
          <label class="field__label">Color del texto</label>
          <div class="field-color">
            <span class="field-input field-input--hex">{{editingScenaryTextColor}}</span>
            <span class="field-color__swatch">
              <input type="color" [(ngModel)]="editingScenaryTextColor"
                (ngModelChange)="updateScenaryTextColor()" (click)="$event.stopPropagation()" />
            </span>
          </div>
        </div>
        <div class="field">
          <label class="field__label">Mostrar icono</label>
          <mat-slide-toggle [(ngModel)]="editingScenaryShowIcon" (ngModelChange)="updateScenaryIcon()" (click)="$event.stopPropagation()" color="primary"></mat-slide-toggle>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!openEditScenary">
    <div *ngIf="!activeTab; else editTab">
      <div class="d-flex justify-content-between align-items-center" *ngIf="fromEvent">
        <p class="title-options-map">Editar Mapa</p>
        <!-- <p>{{capacity}}</p> -->
      </div>
      <div class="options-map">
        <!-- Vista: alternar butacas / zonas -->
        <div class="panel-group" *ngIf="isSuperAdmin && !fromEvent">
          <p class="panel-group__title">Vista</p>
          <div class="section-option" (click)="$event.stopPropagation()" style="gap:8px;" [style.borderColor]="!zoneNavigation ? 'var(--color-primary)' : ''">
            <ng-container *ngIf="zoneNavigation; else enableZoneNav">
              <div style="display:flex; flex-direction:column; width:100%; gap:10px;">
                <div class="seg-toggle">
                  <button type="button" (click)="setMapMode('seats')" [class.active]="mapMode==='seats'">Butacas</button>
                  <button type="button" (click)="setMapMode('zones')" [class.active]="mapMode==='zones'">Zonas</button>
                </div>
                <div class="field" (click)="$event.stopPropagation()">
                  <label class="field__label">Activa para compradores</label>
                  <mat-slide-toggle class="zone-nav-toggle" [(ngModel)]="zoneNavigation" (ngModelChange)="toggleZoneNavigation(); save()" color="primary"></mat-slide-toggle>
                </div>
              </div>
            </ng-container>
            <ng-template #enableZoneNav>
              <div style="width:100%; display:flex; justify-content:space-between; align-items:center;" (click)="confirmEnableZoneNavigation()">
                <p class="m-0" style="color: var(--color-primary); font-family: 'Satoshi-Medium';">Añadir vista general de zonas</p>
                <i class="fa-light fa-map" style="font-size:18px; color: var(--color-primary);"></i>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Plano general (modo zonas) -->
        <div class="panel-group" *ngIf="isSuperAdmin && !fromEvent && mapMode==='zones'">
          <p class="panel-group__title">Plano general</p>
          <p class="field-hint">
            Dibuja el plano general: polígonos (zonas), escenario y textos a tu gusto. Asigna a cada zona sus secciones para que al pulsarla se haga zoom a esas butacas.
          </p>
          <div class="section-option" (click)="autoGenerateZoneShapes()">
            <p class="m-0">Auto-generar zonas</p>
            <i class="fa-light fa-sparkles invisible-icon"></i>
            <i class="fa-light fa-bolt add-icon"></i>
          </div>
        </div>

        <!-- Estructura de butacas -->
        <div class="panel-group" *ngIf="isSuperAdmin && !fromEvent && mapMode==='seats'">
          <p class="panel-group__title">Estructura</p>
          <div class="section-option" (click)="openLevelsMap()">
            <p class="m-0">Niveles</p>
            <i class="fa-light fa-loveseat invisible-icon"></i>
            <i class="fa-light fa-plus add-icon"></i>
          </div>
          <div class="section-option" (click)="openSeatConfigDialog()"
            [class.disabled]="!levels || levels.length === 0"
            [title]="(!levels || levels.length === 0) ? 'Crea un nivel primero' : ''">
            <p class="m-0">Sección de Butacas</p>
            <i class="fa-light fa-loveseat invisible-icon"></i>
            <i class="fa-light fa-plus add-icon"></i>
          </div>
        </div>

        <!-- Elementos del plano -->
        <div class="panel-group" *ngIf="isSuperAdmin && !fromEvent">
          <p class="panel-group__title">Elementos</p>
          <div class="section-option" (click)="addScenary()">
            <p class="m-0">Escenario</p>
            <i class="fa-light fa-tv invisible-icon"></i>
            <i class="fa-light fa-plus add-icon"></i>
          </div>
          <div class="section-option" (click)="addText()">
            <p class="m-0">Texto</p>
            <i class="fa-light fa-input-text invisible-icon"></i>
            <i class="fa-light fa-plus add-icon"></i>
          </div>
          <div class="section-option" (click)="openBackgroundSection=!openBackgroundSection">
            <p class="m-0">Formas</p>
            <i class="fa-light fa-grid-2-plus invisible-icon"></i>
            <i class="fa-light fa-chevron-down add-icon" [class.fa-chevron-up]="openBackgroundSection"></i>
          </div>
          <div class="section-option subsection-add" (click)="addPoligon()" *ngIf="openBackgroundSection">
            <p class="m-0">Polígono</p>
            <i class="fa-light fa-draw-polygon invisible-icon"></i>
            <i class="fa-light fa-plus add-icon"></i>
          </div>
          <div class="section-option subsection-add" (click)="addForm()" *ngIf="openBackgroundSection">
            <p class="m-0">Rectángulo</p>
            <i class="fa-light fa-rectangle invisible-icon"></i>
            <i class="fa-light fa-plus add-icon"></i>
          </div>
          <div class="section-option subsection-add" (click)="addEllipse()" *ngIf="openBackgroundSection">
            <p class="m-0">Círculo / Elipse</p>
            <i class="fa-light fa-circle invisible-icon"></i>
            <i class="fa-light fa-plus add-icon"></i>
          </div>
          <div class="section-option subsection-add" (click)="addLine()" *ngIf="openBackgroundSection">
            <p class="m-0">Línea</p>
            <i class="fa-light fa-slash invisible-icon"></i>
            <i class="fa-light fa-plus add-icon"></i>
          </div>
        </div>

        <!-- Configuración -->
        <div class="panel-group" *ngIf="mapMode==='seats'">
          <p class="panel-group__title">Configuración</p>
          <!-- TODO: leyenda del mapa oculta temporalmente (feature solo-front pendiente de habilitar). Quitar `&& false` para reactivar. -->
          <div class="section-option" (click)="openLegendConfig()" *ngIf="isSuperAdmin && !fromEvent && false">
            <p class="m-0">Leyenda</p>
            <i class="fa-light fa-list invisible-icon"></i>
            <i class="fa-light fa-gear add-icon"></i>
          </div>
          <div class="section-option" (click)="openLevelsHidden('hidden')">
            <p class="m-0">Bloquear asientos</p>
            <i class="fa-light fa-arrow-right"></i>
          </div>
        </div>

        <!-- Capas -->
        <div class="panel-group" *ngIf="isSuperAdmin && !fromEvent">
          <p class="panel-group__title">Capas</p>
          <div class="section-option" (click)="toggleLayersPanel()">
            <p class="m-0">Capas del mapa ({{layersList.length}})</p>
            <i class="fa-light fa-layer-group invisible-icon"></i>
            <i class="fa-light fa-chevron-down add-icon" [class.fa-chevron-up]="openLayersPanel"></i>
          </div>
          <div class="layers-list" *ngIf="openLayersPanel" cdkDropList (cdkDropListDropped)="onLayerDrop($event)">
            <div class="layer-item" *ngFor="let layer of layersList" cdkDrag cdkDragPreviewContainer="parent"
              [class.active]="canvas?.getActiveObject() === layer.fabricObject" [class.layer-item--hidden]="layer.hidden" (click)="selectLayer(layer)">
              <i class="fa-light fa-grip-vertical layer-item__handle" cdkDragHandle></i>
              <i [class]="'layer-item__icon ' + layer.icon"></i>
              <input *ngIf="layer.renaming" class="layer-item__rename-input" type="text" [(ngModel)]="layer.renameValue"
                (click)="$event.stopPropagation()" (keydown.enter)="confirmRenameLayer(layer, $event)"
                (keydown.escape)="cancelRenameLayer(layer, $event)" (blur)="confirmRenameLayer(layer, $event)" cdkFocusInitial />
              <span *ngIf="!layer.renaming" class="layer-item__label" [title]="layer.label" (dblclick)="startRenameLayer(layer, $event)">{{layer.label}}</span>
              <button type="button" class="layer-item__rename" *ngIf="!layer.renaming" title="Renombrar" (click)="startRenameLayer(layer, $event)">
                <i class="fa-light fa-pen"></i>
              </button>
              <button type="button" class="layer-item__visibility" [title]="layer.hidden ? 'Mostrar' : 'Ocultar'" (click)="toggleLayerVisibility(layer, $event)">
                <i class="fa-light" [class.fa-eye]="!layer.hidden" [class.fa-eye-slash]="layer.hidden"></i>
              </button>
              <button type="button" class="layer-item__ungroup" *ngIf="layer.isGroup" title="Desagrupar" (click)="ungroupLayer(layer, $event)">
                <i class="fa-light fa-object-ungroup"></i>
              </button>
              <button type="button" class="layer-item__delete" title="Eliminar" (click)="deleteLayer(layer, $event)">
                <i class="fa-light fa-trash"></i>
              </button>
            </div>
            <p class="field-hint" *ngIf="layersList.length === 0">No hay elementos en el mapa todavía.</p>
          </div>
        </div>
      </div>
    </div>
    <ng-template #editTab>
      <div class="action-bar-object" *ngIf="(openEditObject || openEditSection || openEditText || (openEditImage && !cropModeActive)) && isSuperAdminEditMode">
        <button class="btn-map-action" (click)="duplicateSelected()" title="Duplicar">
          <i class="fa-light fa-copy"></i>
          <span>Duplicar</span>
        </button>
      </div>
      <div *ngIf="(!openEditObject && !openEditSection && !openEditText && !openEditImage)">
        <p class="icon-primary" *ngIf="!fromEvent">ASIENTOS BLOQUEADOS</p>
        <div class="d-flex align-items-center mb-3" (click)="closeTab()" *ngIf="!fromEvent">
          <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
          <p class="m-0">{{titleTab}}</p>
        </div>
        <div *ngIf="fromEvent && openedHidden">
          <div class="d-flex align-items-center">
            <mat-checkbox [(ngModel)]="bookedSeatsShowed" (ngModelChange)="showBookedSeats($event)" class="checkbox"
              color="primary">
            </mat-checkbox>
            <p class="text-checkbox m-0">
              Mostrar asientos ocupados
            </p>
          </div>
        </div>
        <div class="options-map" *ngIf="openedHidden">
          <div>
            <app-hidden-seats [capacity]="capacity" [hiddenTypes]="hiddenTypes" [canvas]="canvas" [idSpace]="idSpace"
              [selectedSeats]="selectedHidden" [assignedHidden]="hiddenSeats" [fromEvent]="fromEvent"
              [idEvent]="idEvent" (changeAssigned)="assignedSeatsHidden($event)"
              (typeAssigned)="activeEditHidden($event)" [admin]="(profile|async)?.admin" [fromCreate]="fromCreate"
              [selectedSession]="selectedSession"></app-hidden-seats>
          </div>
        </div>
      </div>
      <div class="options-map" *ngIf="openEditObject && objectEditing">
        <app-edit-section [canvas]="canvas" [sectionElement]="objectEditing" [levels]="levels"
                    [colorDefaultSeat]="colorDefaultSeat" [sitSelect]="sitSelect"
                    [seatsEditSelected]="seatsEditSelected" [openSeatEditing]="openSeatEditing"
                    (activeEdit)="activeEdit($event)" (updateCanvas)="updateCanvas($event)"
                    (setHiddenSectionMode)="setHiddenSectionEditMode($event)"
                    (setSpecialSeatMode)="setSpecialSeatEditMode($event)"
                    (rebuildSection)="rebuildSectionOnCanvas($event)"
                    (rebuildRadialSections)="rebuildRadialSectionsOnCanvas($event)"
                    (closeTab)="closeTab()"></app-edit-section>
      </div>
      <div class="options-map" *ngIf="curveSelectionActive">
        <app-curve-selection-panel [mode]="curveMode" [placingCenter]="curvePlacingCenter"
                    [radius]="curveRadius" [arcDeg]="curveArcDeg" [ellipseAspect]="curveEllipseAspect"
                    [ellipseRotation]="curveEllipseRotation" [curvature]="curveCurvature" [invert]="curveInvert"
                    (modeChange)="onCurveModeChange($event)" (togglePlacingCenter)="toggleCurvePlacingCenter()"
                    (radiusChange)="onCurveRadiusChange($event)" (arcDegChange)="onCurveArcDegChange($event)"
                    (ellipseAspectChange)="onCurveEllipseAspectChange($event)"
                    (ellipseRotationChange)="onCurveEllipseRotationChange($event)"
                    (curvatureChange)="onCurveCurvatureChange($event)" (invertChange)="onCurveInvertToggle()"
                    (apply)="commitCurveSelection()" (cancel)="cancelCurveSelection()"></app-curve-selection-panel>
      </div>
      <div class="options-map" *ngIf="multiSelectionActive && !curveSelectionActive && isSuperAdminEditMode">
        <div class="edit-seats-object">
          <div class="options-edit-section active">
            <div class="section-edit">
              <p class="panel-group__title m-0">Selección múltiple</p>
              <div class="field-range">
                <div class="field-range__head">
                  <label class="field-label">Rotación del grupo</label>
                  <span class="field-range__value">
                    <input type="number" min="-180" max="180" step="1" [(ngModel)]="groupRotationAngle" (input)="onGroupRotationChange(groupRotationAngle)">
                    <span class="field-range__unit">°</span>
                  </span>
                </div>
                <input type="range" min="-180" max="180" step="1" [(ngModel)]="groupRotationAngle"
                  (input)="onGroupRotationChange(groupRotationAngle)" class="slider-rotation">
              </div>
              <button type="button" class="btn-map-action" (click)="startCurveSelection()">
                <i class="fa-regular fa-bezier-curve"></i> Curvar selección
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="options-map" *ngIf="openEditSection">
        <app-edit-info-section [canvas]="canvas" [sectionElement]="objectEditing"
                    [colorDefault]="colorDefaultStage" [levels]="levels"
                    [availableLevels]="levelsList"
                    [availableShapes]="availableShapesList"
                    (updateCanvas)="saveColorSection($event)"
                    (closeTab)="closeTab()"></app-edit-info-section>
      </div>
      <div class="options-map" *ngIf="openEditText">
        <div class="edit-seats-object">
          <div class="d-flex align-items-center mb-3 title-section" (click)="clearedObjectSelect()">
            <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
            <p class="m-0">Texto</p>
          </div>
          <div class="panel-group">
            <div class="field field--stacked">
              <label class="field__label">Texto</label>
              <input class="field-input" type="text" [(ngModel)]="editingTextContent" (input)="updateTextContent()">
            </div>
            <div class="field">
              <label class="field__label">Identificador</label>
              <input class="field-input" type="text" [(ngModel)]="editingTextObjectId" (change)="updateTextObjectId()">
            </div>
            <div class="field">
              <label class="field__label">Tamaño de fuente</label>
              <input class="field-input field-input--sm" type="number" min="1" [(ngModel)]="editingTextFontSize" (change)="updateTextFontSize()" required>
            </div>
            <div class="field">
              <label class="field__label">Interlineado</label>
              <input class="field-input field-input--sm" type="number" min="0.5" step="0.1" [(ngModel)]="editingTextLineHeight" (change)="updateTextLineHeight()" required>
            </div>
            <div class="field">
              <label class="field__label">Color del texto</label>
              <div class="field-color">
                <span class="field-input field-input--hex">{{editingTextColor}}</span>
                <span class="field-color__swatch">
                  <input type="color" [(ngModel)]="editingTextColor" (ngModelChange)="updateTextColor()" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="options-map" *ngIf="openEditImage && editingImageObject">
        <div class="edit-seats-object">
          <div class="d-flex align-items-center mb-3 title-section" (click)="clearedObjectSelect()">
            <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
            <p class="m-0">{{ editingImageObject.isSvgImage ? 'SVG' : 'Imagen' }}</p>
          </div>
          <div class="panel-group" *ngIf="!cropModeActive">
            <p class="panel-group__title">Transformación</p>
            <div class="field-range">
              <div class="field-range__head">
                <label class="field__label">Rotar</label>
                <span class="field-range__value">
                  <input type="number" min="-180" max="180" step="1" [(ngModel)]="editingImageAngle" (input)="updateImageAngle(editingImageAngle)">
                  <span class="field-range__unit">°</span>
                </span>
              </div>
              <input type="range" min="-180" max="180" step="1" [(ngModel)]="editingImageAngle" (input)="updateImageAngle(editingImageAngle)" class="slider-rotation">
            </div>
          </div>
          <div class="panel-group" *ngIf="!cropModeActive">
            <button class="btn-map-action" *ngIf="!editingImageObject.isSvgImage" (click)="startCropImage()" title="Recortar imagen">
              <i class="fa-light fa-crop-simple"></i>
              <span>Recortar imagen</span>
            </button>
            <button class="btn-map-action" (click)="bringImageToFront()" title="Traer al frente">
              <i class="fa-light fa-arrow-up-to-line"></i>
              <span>Traer al frente</span>
            </button>
            <button class="btn-map-action" (click)="sendImageToBack()" title="Enviar al fondo">
              <i class="fa-light fa-arrow-down-to-line"></i>
              <span>Enviar al fondo</span>
            </button>
          </div>
          <div class="panel-group" *ngIf="cropModeActive">
            <p class="m-0" style="font-size: 13px; color: #6c757d;">
              Ajusta el recuadro sobre el área que quieras conservar y pulsa Aplicar.
            </p>
            <div class="d-flex" style="gap: 8px;">
              <button class="btn-map-action" (click)="applyCropImage()" title="Aplicar recorte">
                <i class="fa-light fa-check"></i>
                <span>Aplicar</span>
              </button>
              <button class="btn-map-action" (click)="cancelCropImage()" title="Cancelar recorte">
                <i class="fa-light fa-xmark"></i>
                <span>Cancelar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    </ng-container>
    <!-- <div class="delete-link" *ngIf="(profile|async)?.admin">
            <p *ngIf="idMap" (click)="deleteMap()">Eliminar mapa</p>
        </div> -->
  </div>
  <div class="offcanvas offcanvas-end" [class.show]="!isOffCanvasOpen" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel">{{activeTab ? titleTab : 'Opciones del mapa'}}</h5>
      <button type="button" class="btn-close" (click)="toggleOffcanvas()" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <div class="aside-options w-100" *ngIf="allowCreate">
        <div *ngIf="openEditScenary">
          <div class="d-flex align-items-center mb-3" (click)="closeScenaryEdit()">
            <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
            <p class="m-0">Escenario</p>
          </div>
          <div class="options-map">
            <div class="section-option flex-column align-items-start" style="gap: 8px;">
              <label class="m-0" style="font-size: 13px;">Nombre del escenario</label>
              <div class="d-flex w-100" style="gap: 8px;">
                <input class="form-control form-control-sm" type="text" [(ngModel)]="editingScenaryText"
                  (ngModelChange)="updateScenaryText()" placeholder="Escenario" (click)="$event.stopPropagation()" />
              </div>
            </div>
            <div class="section-option flex-column align-items-start" style="gap: 8px;">
              <label class="m-0" style="font-size: 13px;">Color del escenario</label>
              <div class="d-flex w-100 align-items-center" style="gap: 8px;">
                <input type="color" [(ngModel)]="editingScenaryColor"
                  (ngModelChange)="updateScenaryColor()" (click)="$event.stopPropagation()" style="width: 40px; height: 32px; padding: 2px; border: 1px solid #ced4da; border-radius: 4px; cursor: pointer;" />
                <span style="font-size: 12px; color: #6c757d;">{{editingScenaryColor}}</span>
              </div>
            </div>
            <div class="section-option flex-column align-items-start" style="gap: 8px;">
              <label class="m-0" style="font-size: 13px;">Tamaño de fuente</label>
              <input class="form-control form-control-sm" type="number" min="8" max="120" [(ngModel)]="editingScenaryFontSize"
                (ngModelChange)="updateScenaryFontSize()" (click)="$event.stopPropagation()" style="width: 80px;" />
            </div>
            <div class="section-option flex-column align-items-start" style="gap: 8px;">
              <label class="m-0" style="font-size: 13px;">Color del texto</label>
              <div class="d-flex w-100 align-items-center" style="gap: 8px;">
                <input type="color" [(ngModel)]="editingScenaryTextColor"
                  (ngModelChange)="updateScenaryTextColor()" (click)="$event.stopPropagation()" style="width: 40px; height: 32px; padding: 2px; border: 1px solid #ced4da; border-radius: 4px; cursor: pointer;" />
                <span style="font-size: 12px; color: #6c757d;">{{editingScenaryTextColor}}</span>
              </div>
            </div>
            <div class="section-option" style="justify-content: space-between;">
              <label class="m-0" style="font-size: 13px;">Mostrar icono</label>
              <mat-slide-toggle [(ngModel)]="editingScenaryShowIcon" (ngModelChange)="updateScenaryIcon()" (click)="$event.stopPropagation()"></mat-slide-toggle>
            </div>
          </div>
        </div>
        <ng-container *ngIf="!openEditScenary">
        <div *ngIf="!activeTab; else editTab">
          <div class="d-flex justify-content-between align-items-center" *ngIf="fromEvent">
            <p class="title-options-map">Editar Mapa</p>
          </div>
          <div class="options-map">
            <div class="section-option" *ngIf="isSuperAdmin && !fromEvent" (click)="$event.stopPropagation()" style="gap:8px;" [style.borderColor]="!zoneNavigation ? 'var(--color-primary)' : ''">
              <ng-container *ngIf="zoneNavigation; else enableZoneNav2">
                <div style="display:flex; flex-direction:column; width:100%; gap:6px;">
                  <div style="display:flex; width:100%; background:#f0f0f0; border-radius:20px; padding:3px;">
                    <button type="button" (click)="setMapMode('seats')" [style.background]="mapMode==='seats' ? '#FF4D80' : 'transparent'" [style.color]="mapMode==='seats' ? '#fff' : '#555'" style="flex:1; border:none; border-radius:18px; padding:6px 10px; cursor:pointer; font-size:13px;">Butacas</button>
                    <button type="button" (click)="setMapMode('zones')" [style.background]="mapMode==='zones' ? '#FF4D80' : 'transparent'" [style.color]="mapMode==='zones' ? '#fff' : '#555'" style="flex:1; border:none; border-radius:18px; padding:6px 10px; cursor:pointer; font-size:13px;">Zonas</button>
                  </div>
                  <div style="display:flex; justify-content:space-between; align-items:center;" (click)="$event.stopPropagation()">
                    <label class="m-0" style="font-size:12px; color:#666;">Activa para compradores</label>
                    <mat-slide-toggle class="zone-nav-toggle" [(ngModel)]="zoneNavigation" (ngModelChange)="toggleZoneNavigation(); save()" color="primary"></mat-slide-toggle>
                  </div>
                </div>
              </ng-container>
              <ng-template #enableZoneNav2>
                <div style="width:100%; display:flex; justify-content:space-between; align-items:center;" (click)="confirmEnableZoneNavigation()">
                  <p class="m-0" style="color: var(--color-primary); font-family: 'Satoshi-Medium';">Añadir vista general de zonas</p>
                  <i class="fa-light fa-map" style="font-size:18px; color: var(--color-primary);"></i>
                </div>
              </ng-template>
            </div>
            <p class="m-0 link" *ngIf="isSuperAdmin && !fromEvent && mapMode==='zones'" style="font-size:12px; white-space:normal; margin-bottom:6px;">
              Dibuja el plano general: polígonos (zonas), escenario y textos a tu gusto. Asigna a cada zona sus secciones para que al pulsarla se haga zoom a esas butacas.
            </p>
            <div class="section-option" (click)="autoGenerateZoneShapes()" *ngIf="isSuperAdmin && !fromEvent && mapMode==='zones'">
              <p class="m-0">Auto-generar zonas</p>
              <i class="fa-light fa-sparkles invisible-icon"></i>
              <i class="fa-light fa-bolt add-icon"></i>
            </div>
            <div class="section-option" (click)="openLevelsMap()" *ngIf="isSuperAdmin && !fromEvent && mapMode==='seats'">
              <p class="m-0">Niveles</p>
              <i class="fa-light fa-loveseat invisible-icon"></i>
              <i class="fa-light fa-plus add-icon"></i>
            </div>
            <!-- TODO: leyenda del mapa oculta temporalmente (feature solo-front pendiente de habilitar). Quitar `&& false` para reactivar. -->
            <div class="section-option" (click)="openLegendConfig()" *ngIf="isSuperAdmin && !fromEvent && mapMode==='seats' && false">
              <p class="m-0">Leyenda</p>
              <i class="fa-light fa-list invisible-icon"></i>
              <i class="fa-light fa-gear add-icon"></i>
            </div>
            <div class="section-option" (click)="addScenary()" *ngIf="isSuperAdmin && !fromEvent">
              <p class="m-0">Escenario</p>
              <i class="fa-light fa-tv invisible-icon"></i>
              <i class="fa-light fa-plus add-icon"></i>
            </div>
            <div class="section-option" (click)="openSeatConfigDialog()" *ngIf="isSuperAdmin && !fromEvent && mapMode==='seats'"
              [class.disabled]="!levels || levels.length === 0"
              [title]="(!levels || levels.length === 0) ? 'Crea un nivel primero' : ''">
              <p class="m-0">Sección de Butacas</p>
              <i class="fa-light fa-loveseat invisible-icon"></i>
              <i class="fa-light fa-plus add-icon"></i>
            </div>
            <!-- <div class="section-option" (click)="addSectionFree()" *ngIf="((profile|async)?.admin || isSuperAdmin) && !fromEvent">
              <p class="m-0">Sección sin numerar</p>
              <i class="fa-light fa-seat-airline invisible-icon"></i>
              <i class="fa-light fa-plus add-icon"></i>
            </div>
            <div class="section-option" (click)="addStandSection()" *ngIf="((profile|async)?.admin || isSuperAdmin) && !fromEvent">
              <p class="m-0">Pista</p>
              <i class="fa-light fa-shoe-prints invisible-icon"></i>
              <i class="fa-light fa-plus add-icon"></i>
            </div> -->
            <div class="section-option" (click)="addText()" *ngIf="isSuperAdmin && !fromEvent">
              <p class="m-0">Texto</p>
              <i class="fa-light fa-input-text invisible-icon"></i>
              <i class="fa-light fa-plus add-icon"></i>
            </div>
            <div class="section-option" (click)="openBackgroundSection=!openBackgroundSection" *ngIf="isSuperAdmin && !fromEvent">
              <p class="m-0">Formas</p>
              <i class="fa-light fa-grid-2-plus invisible-icon"></i>
              <i class="fa-light fa-chevron-down add-icon" [class.fa-chevron-up]="openBackgroundSection"></i>
            </div>
            <div class="section-option subsection-add" (click)="addPoligon()" *ngIf="openBackgroundSection && isSuperAdmin && !fromEvent">
              <p class="m-0">Polígono</p>
              <i class="fa-light fa-draw-polygon invisible-icon"></i>
              <i class="fa-light fa-plus add-icon"></i>
            </div>
            <div class="section-option subsection-add" (click)="addForm()" *ngIf="openBackgroundSection && isSuperAdmin && !fromEvent">
              <p class="m-0">Rectángulo</p>
              <i class="fa-light fa-rectangle invisible-icon"></i>
              <i class="fa-light fa-plus add-icon"></i>
            </div>
            <div class="section-option" (click)="openLevelsHidden('hidden')" *ngIf="mapMode==='seats'">
              <p class="m-0">Bloquear asientos</p>
              <i class="fa-light fa-arrow-right"></i>
            </div>
            <div class="section-option" (click)="toggleLayersPanel()" *ngIf="isSuperAdmin && !fromEvent">
              <p class="m-0">Capas del mapa ({{layersList.length}})</p>
              <i class="fa-light fa-layer-group invisible-icon"></i>
              <i class="fa-light fa-chevron-down add-icon" [class.fa-chevron-up]="openLayersPanel"></i>
            </div>
            <div class="layers-list" *ngIf="openLayersPanel && isSuperAdmin && !fromEvent" cdkDropList (cdkDropListDropped)="onLayerDrop($event)">
              <div class="layer-item" *ngFor="let layer of layersList" cdkDrag
                [class.active]="canvas?.getActiveObject() === layer.fabricObject" [class.layer-item--hidden]="layer.hidden" (click)="selectLayer(layer)">
                <i class="fa-light fa-grip-vertical layer-item__handle" cdkDragHandle></i>
                <i [class]="'layer-item__icon ' + layer.icon"></i>
                <input *ngIf="layer.renaming" class="layer-item__rename-input" type="text" [(ngModel)]="layer.renameValue"
                  (click)="$event.stopPropagation()" (keydown.enter)="confirmRenameLayer(layer, $event)"
                  (keydown.escape)="cancelRenameLayer(layer, $event)" (blur)="confirmRenameLayer(layer, $event)" cdkFocusInitial />
                <span *ngIf="!layer.renaming" class="layer-item__label" [title]="layer.label" (dblclick)="startRenameLayer(layer, $event)">{{layer.label}}</span>
                <button type="button" class="layer-item__rename" *ngIf="!layer.renaming" title="Renombrar" (click)="startRenameLayer(layer, $event)">
                  <i class="fa-light fa-pen"></i>
                </button>
                <button type="button" class="layer-item__visibility" [title]="layer.hidden ? 'Mostrar' : 'Ocultar'" (click)="toggleLayerVisibility(layer, $event)">
                  <i class="fa-light" [class.fa-eye]="!layer.hidden" [class.fa-eye-slash]="layer.hidden"></i>
                </button>
                <button type="button" class="layer-item__ungroup" *ngIf="layer.isGroup" title="Desagrupar" (click)="ungroupLayer(layer, $event)">
                  <i class="fa-light fa-object-ungroup"></i>
                </button>
                <button type="button" class="layer-item__delete" title="Eliminar" (click)="deleteLayer(layer, $event)">
                  <i class="fa-light fa-trash"></i>
                </button>
              </div>
              <p class="field-hint" *ngIf="layersList.length === 0">No hay elementos en el mapa todavía.</p>
            </div>
          </div>
        </div>
        <ng-template #editTab>
          <div class="action-bar-object" *ngIf="(openEditObject || openEditSection || openEditText || (openEditImage && !cropModeActive)) && isSuperAdminEditMode">
            <button class="btn-map-action" (click)="duplicateSelected()" title="Duplicar">
              <i class="fa-light fa-copy"></i>
              <span>Duplicar</span>
            </button>
          </div>
          <div *ngIf="(!openEditObject && !openEditSection && !openEditText && !openEditImage)">
            <p class="icon-primary" *ngIf="!fromEvent">ASIENTOS BLOQUEADOS</p>
            <div class="d-flex align-items-center mb-3" (click)="closeTab()" *ngIf="!fromEvent">
              <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
              <p class="m-0">{{titleTab}}</p>
            </div>
            <div *ngIf="fromEvent && openedHidden">
              <div class="d-flex align-items-center">
                <mat-checkbox [(ngModel)]="bookedSeatsShowed" (ngModelChange)="showBookedSeats($event)" class="checkbox"
                  color="primary">
                </mat-checkbox>
                <p class="text-checkbox m-0">
                  Mostrar asientos ocupados
                </p>
              </div>
            </div>
            <div class="options-map" *ngIf="openedHidden">
              <div>
                <app-hidden-seats [capacity]="capacity" [hiddenTypes]="hiddenTypes" [canvas]="canvas"
                  [idSpace]="idSpace" [selectedSeats]="selectedHidden" [assignedHidden]="hiddenSeats"
                  [fromEvent]="fromEvent" [idEvent]="idEvent" (changeAssigned)="assignedSeatsHidden($event)"
                  (typeAssigned)="activeEditHidden($event)" [admin]="(profile|async)?.admin" [fromCreate]="fromCreate"
                  [selectedSession]="selectedSession"></app-hidden-seats>
              </div>
            </div>
          </div>
          <div class="options-map" *ngIf="openEditObject && objectEditing">
            <app-edit-section [canvas]="canvas" [sectionElement]="objectEditing" [levels]="levels"
                      [colorDefaultSeat]="colorDefaultSeat" [sitSelect]="sitSelect"
                      [seatsEditSelected]="seatsEditSelected" [openSeatEditing]="openSeatEditing"
                      (activeEdit)="activeEdit($event)" (updateCanvas)="updateCanvas($event)"
                      (setHiddenSectionMode)="setHiddenSectionEditMode($event)"
                      (setSpecialSeatMode)="setSpecialSeatEditMode($event)"
                      (rebuildSection)="rebuildSectionOnCanvas($event)"
                      (rebuildRadialSections)="rebuildRadialSectionsOnCanvas($event)"
                      (closeTab)="closeTab()"></app-edit-section>
          </div>
          <div class="options-map" *ngIf="curveSelectionActive">
            <app-curve-selection-panel [mode]="curveMode" [placingCenter]="curvePlacingCenter"
                      [radius]="curveRadius" [arcDeg]="curveArcDeg" [ellipseAspect]="curveEllipseAspect"
                      [ellipseRotation]="curveEllipseRotation" [curvature]="curveCurvature" [invert]="curveInvert"
                      (modeChange)="onCurveModeChange($event)" (togglePlacingCenter)="toggleCurvePlacingCenter()"
                      (radiusChange)="onCurveRadiusChange($event)" (arcDegChange)="onCurveArcDegChange($event)"
                      (ellipseAspectChange)="onCurveEllipseAspectChange($event)"
                      (ellipseRotationChange)="onCurveEllipseRotationChange($event)"
                      (curvatureChange)="onCurveCurvatureChange($event)" (invertChange)="onCurveInvertToggle()"
                      (apply)="commitCurveSelection()" (cancel)="cancelCurveSelection()"></app-curve-selection-panel>
          </div>
          <div class="options-map" *ngIf="multiSelectionActive && !curveSelectionActive && isSuperAdminEditMode">
            <div class="edit-seats-object">
              <div class="options-edit-section active">
                <div class="section-edit">
                  <p class="panel-group__title m-0">Selección múltiple</p>
                  <div class="field-range">
                    <div class="field-range__head">
                      <label class="field-label">Rotación del grupo</label>
                      <span class="field-range__value">
                        <input type="number" min="-180" max="180" step="1" [(ngModel)]="groupRotationAngle" (input)="onGroupRotationChange(groupRotationAngle)">
                        <span class="field-range__unit">°</span>
                      </span>
                    </div>
                    <input type="range" min="-180" max="180" step="1" [(ngModel)]="groupRotationAngle"
                      (input)="onGroupRotationChange(groupRotationAngle)" class="slider-rotation">
                  </div>
                  <button type="button" class="btn-map-action" (click)="startCurveSelection()">
                    <i class="fa-regular fa-bezier-curve"></i> Curvar selección
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="options-map" *ngIf="openEditSection">
            <app-edit-info-section [canvas]="canvas" [sectionElement]="objectEditing"
                      [colorDefault]="colorDefaultStage" [levels]="levels"
                      [availableLevels]="levelsList"
                      (updateCanvas)="saveColorSection($event)"
                      (closeTab)="closeTab()"></app-edit-info-section>
          </div>
          <div class="options-map" *ngIf="openEditText">
            <div class="edit-seats-object">
              <div class="d-flex align-items-center mb-3 title-section" (click)="clearedObjectSelect()">
                <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
                <p class="m-0">Texto</p>
              </div>
              <div class="section-edit">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <p class="m-0">Identificador:</p>
                  <div class="bloque-change-section container-form d-flex align-items-center">
                    <input type="text" [(ngModel)]="editingTextObjectId" (change)="updateTextObjectId()">
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <p class="m-0">Texto:</p>
                  <div class="bloque-change-section container-form d-flex align-items-center">
                    <input type="text" [(ngModel)]="editingTextContent" (input)="updateTextContent()">
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <p class="m-0">Tamaño de fuente:</p>
                  <div class="bloque-change-section container-form d-flex align-items-center change-number">
                    <input type="number" min="1" [(ngModel)]="editingTextFontSize" (change)="updateTextFontSize()" required>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <p class="m-0">Color del texto:</p>
                  <div class="bloque-change-section container-form d-flex align-items-center" style="gap: 8px;">
                    <input type="color" [(ngModel)]="editingTextColor" (ngModelChange)="updateTextColor()" style="width: 40px; height: 32px; padding: 2px; border: 1px solid #ced4da; border-radius: 4px; cursor: pointer;" />
                    <span style="font-size: 12px; color: #6c757d;">{{editingTextColor}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="options-map" *ngIf="openEditImage && editingImageObject">
            <div class="edit-seats-object">
              <div class="d-flex align-items-center mb-3 title-section" (click)="clearedObjectSelect()">
                <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
                <p class="m-0">Imagen</p>
              </div>
              <div class="panel-group" *ngIf="!cropModeActive">
                <p class="panel-group__title">Transformación</p>
                <div class="field-range">
                  <div class="field-range__head">
                    <label class="field__label">Rotar</label>
                    <span class="field-range__value">
                      <input type="number" min="-180" max="180" step="1" [(ngModel)]="editingImageAngle" (input)="updateImageAngle(editingImageAngle)">
                      <span class="field-range__unit">°</span>
                    </span>
                  </div>
                  <input type="range" min="-180" max="180" step="1" [(ngModel)]="editingImageAngle" (input)="updateImageAngle(editingImageAngle)" class="slider-rotation">
                </div>
              </div>
              <div class="panel-group" *ngIf="!cropModeActive">
                <button class="btn-map-action" (click)="startCropImage()" title="Recortar imagen">
                  <i class="fa-light fa-crop-simple"></i>
                  <span>Recortar imagen</span>
                </button>
                <button class="btn-map-action" (click)="bringImageToFront()" title="Traer al frente">
                  <i class="fa-light fa-arrow-up-to-line"></i>
                  <span>Traer al frente</span>
                </button>
                <button class="btn-map-action" (click)="sendImageToBack()" title="Enviar al fondo">
                  <i class="fa-light fa-arrow-down-to-line"></i>
                  <span>Enviar al fondo</span>
                </button>
              </div>
              <div class="panel-group" *ngIf="cropModeActive">
                <p class="m-0" style="font-size: 13px; color: #6c757d;">
                  Ajusta el recuadro sobre el área que quieras conservar y pulsa Aplicar.
                </p>
                <div class="d-flex" style="gap: 8px;">
                  <button class="btn-map-action" (click)="applyCropImage()" title="Aplicar recorte">
                    <i class="fa-light fa-check"></i>
                    <span>Aplicar</span>
                  </button>
                  <button class="btn-map-action" (click)="cancelCropImage()" title="Cancelar recorte">
                    <i class="fa-light fa-xmark"></i>
                    <span>Cancelar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>
